import React from 'react'
import { Grid } from "@mui/material";
import { UiInputGroupWr } from "../../../../../_uiComponents/common/form/UiInputComponents";
import UiInput from "../../../../../_uiMocks/_uiComponents/UiInput";
import UiSwitch from "../../../../../_uiMocks/_uiComponents/UiSwitch"
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from '@mui/material/Stack';
import {
    UiButton,
} from "../../../../../_uiComponents/common/form/UiButton";
import UiDateRangePicker from '../../../../_uiComponents/UiDateRangePicker';
import UiRuleBuilder from "../../../../../_uiMocks/_uiComponents/UiRuleBuilder";
import { SearchBarWr } from "../../../../../_uiComponents/common/form/UiInputComponents";
import { UiAccordian } from "../../../../../_uiComponents/common/form/UiToggleArea";
import MeasurementsFilterForm from './forms/MeasurementsFilterForm';
import MeasurementsTable from './MeasurementsTable';

export default function Measurements(props) {

    return (
        <>
            <UiInputGroupWr
                title="Create Measurements"
            >
                <Grid container spacing={2} sx={{ mb: 1 }}>
                    <Grid
                        item
                        xs="12"
                        lg="6"
                    >
                        <UiInput
                            type="text"
                            label="Name"
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid
                        item
                        xs="12"
                        lg="6"
                    >
                        <UiDateRangePicker />

                    </Grid>
                </Grid>
                <Grid container spacing={2}>

                    <Grid
                        item
                        xs="12"
                        lg="12"
                    >
                        <span className='sbm-rule-label'>Rule</span>
                        <UiRuleBuilder />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid
                        item
                        xs="12"
                        lg="12"
                    >
                        <FormControlLabel control={
                            <UiSwitch />}
                            label="Active"
                            labelPlacement="top"
                            sx={{ mt: 2 }}
                            className='sba-campaign-switch-label' />
                    </Grid>

                    <Grid item xs="12" lg="12" sx={{ mb: 2 }} >
                        <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%' }}>
                            <UiButton name="Clear" variant="outlined" size="small" />
                            <UiButton name="Save" variant="contained" size="small" />
                        </Stack>
                    </Grid>
                </Grid>
                 <div className='sb-measurement-filter-area'>               
                    <UiAccordian>
                        <SearchBarWr>
                            <MeasurementsFilterForm/>
                        </SearchBarWr>
                    </UiAccordian>
                </div>
                <MeasurementsTable/>
            </UiInputGroupWr>
        </>
    )
}
